/** @format */

import React, { useCallback, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import ProductFormNav from "./ProductFormNav";
import ProductAdd from "./ProductAdd";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader";
import { AddProducts } from "../../../Utils/Constants";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";
import { useDispatch } from "react-redux";

export default function AddProduct({ product_id }: { product_id: any }) {
  const [steps, setSteps] = useState(1);
  const dispatch = useDispatch();
  const activeCallBack = useCallback((tab: number) => {
    setSteps(tab);
  }, []);

  return (
    <div className="page-body main-project">
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <Button
                  color="success"
                  onClick={() => dispatch(openView("products"))}
                >
                  All Products
                </Button>
              </CardHeader>
              <CardBody>
                <Row className="g-xl-5 g-3">
                  <ProductFormNav steps={steps} setSteps={setSteps} />
                  <ProductAdd
                    product_id={product_id}
                    steps={steps}
                    activeCallBack={activeCallBack}
                  />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
